<template>
    <div>
		<el-popover
			v-model="isShow"
			popper-class="_header__popover"
			placement="bottom"
			trigger="hover"
			@show="rotateDeg = '180deg'"
			@hide="rotateDeg = '0deg'"
		>
			<!-- <p>点击店铺名称切换</p> -->
			<div class="header-popover-content">
				<div class="header-popover-content-top">
					<div class="left">
						<img
							:src="shopInfo.logo_image_url ? getQiniuImgUrl(shopInfo.logo_image_url) : shopDefaultLogo"
							alt
						/>
					</div>
					<div class="right">
						<h1 style="width: 300px" class="text-popper" v-textPopper>{{ shopInfo.shop_name }}</h1>
						<p>
							<auth-status :shopInfo="shopInfo" />
						</p>
						<p>{{ shopInfo.expired_time }}到期，森果已陪伴您{{ shopInfo.day_has_member }}天</p>
					</div>
				</div>
				<div class="header-popover-content-bottom">
					<button class="switch-btn" @click="goToCenter">切换店铺</button>
					<button class="renew-btn" @click="goToRenew">
						<span>{{ renewText(shopInfo) }}</span>
						<i class="iconfont icongonggongfanhui" />
					</button>
				</div>
			</div>
			<div class="station-container" slot="reference">
				<h1>
					<span
						class="text-popper"
						style="width: auto; max-width: calc(100% - 32px)"
						v-textPopper
					>{{ shopInfo.shop_name }}</span>
					<i :style="{ transform: `rotate(${rotateDeg})` }" class="el-icon el-icon-arrow-down" />
				</h1>
				<input type="text" />
			</div>
		</el-popover>
	</div>
</template>

<script>
import { mapState } from "vuex"

import AuthStatus from "@/components/auth_status/auth_status.vue"

// shop logo
import shopDefaultLogo from "../../../configuration/shop_info/images/shop_default.svg"
import { getQiniuImgUrl } from "@/assets/ts/qiniu"
import { openNewRenew } from '@/components/new_renew/new_renew.tsx'

import domain from "@/config/domain"
import { openMessage } from '@/utils/system'

export default {
	data() {
		return {
			shopDefaultLogo,
			isShow: false,
			rotateDeg: "0deg"
		};
	},

	computed: {
		...mapState("shop", ["shopInfo"])
	},

	created() {
		this.getQiniuImgUrl = getQiniuImgUrl
	},

	methods: {
		goToCenter() {
			// 去商户中心
			window.location.href = domain.center + "/#/main/shopList"
		},

		goToRenew() {
			// 去续费页
			this.isShow = false
			openMessage('info', '请前往零售通客户端操作')
            // openNewRenew()  // 调用续费弹框
		},

		renewText(shopInfo) {
			if (shopInfo.use_status === 0) {
				return "开通正式版"
			} else if (shopInfo.use_status === 1) {
				return "升级/续费"
			}
		}
	},

	computed: {
		...mapState("shop", ["shopInfo", "userInfo"])
	},

	components: {
		AuthStatus
	}
}
</script>

<style lang="scss">
body ._header__popover {
	width: 428px;
	padding: 12px;
	transform: translate(0, -20px);
	animation: headermidpopper 0.4s;
	transition: all 0.4s;

	&[aria-hidden="true"] {
		transform: translate(0, -20px) scale(0);
	}

	&[aria-hidden="false"] {
		transform: translate(0, -20px) scale(1);
	}

	@keyframes headermidpopper {
		from {
			transform: translate(0, -20px) scale(0);
		}
		to {
			transform: translate(0, -20px) scale(1);
		}
	}
}
</style>

<style lang="scss" scoped>
.station-container {
	position: relative;
	display: inline-block;
	cursor: pointer;

	input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
	}

	i {
		transition: transform 0.5s;
	}

	ul {
		position: absolute;
		left: 50%;
		margin-left: -120px;
		width: 240px;
		background: #fff;
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
		z-index: 100;

		li {
			padding-left: 10px;
			margin-top: 5px;
			margin-bottom: 5px;
			font-size: 14px;
			color: #333;
			letter-spacing: 0;
			line-height: 30px;

			&:hover {
				background: #f7f7f7;
			}
		}

		&::before {
			content: "";
			position: absolute;
			top: -5px;
			left: 50%;
			width: 10px;
			height: 10px;
			transform: translateX(-50%) rotate(45deg);
			background: #fff;
		}
	}

	.slide-fade-enter-active {
		transition: all 0.5s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.5s ease;
	}

	.slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
		transform: translateY(-20px);
		opacity: 0;
	}
}
.el-icon-arrow-down {
	margin-left: 8px;
	transition: all 0.25s;
}

.header-popover-content {
    &-top {
        display: flex;
        align-items: center;

        .left {
            width: 68px;
            height: 68px;
            margin-right: 8px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .right {
            color: #333;

            h1 {
                font-size: 20px;
                font-weight: 600;
                line-height: 28px;
            }

            p {
                display: flex;
                align-items: center;
                color: #333;
                font-size: 12px;
                line-height: 16px;

                &:not(:first-child) {
                    margin-top: 7px;
                }
            }
        }
    }

    &-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        button + button {
            margin-left: 12px;
        }

        button {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 156px;
            height: 36px;
            padding: 0;
            border: none;
            outline: none;
            box-sizing: border-box;
            border-radius: 5px;
            font-size: 14px;

            &:hover {
                opacity: .6;
            }

            &:active {
                opacity: .6;
                transform: scale(.9);
            }
        }

        .switch-btn {
            border: 1px solid rgba(51,51,51,1);
            background: #fff;
            cursor: pointer;
        }

        .renew-btn {
            background: linear-gradient(#FDEDCF, #FEEFD3);
            color: #BE8A0B;
            overflow: hidden;
            cursor: pointer;

            &:active {
                opacity: 1;
            }

            &:active::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .2);
            }

            i {
                display: inline-flex;
                align-items: center;
                margin-left: 4px;

                &::before {
                    display: inline-block;
                    font-size: 12px;
                    transform: rotateZ(180deg);
                }
            }
        }
    }
	&-top {
		display: flex;
		align-items: center;

		.left {
			width: 68px;
			height: 68px;
			margin-right: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.right {
			color: #333;

			h1 {
				font-size: 20px;
				font-weight: 600;
				line-height: 28px;
			}

			p {
				display: flex;
				align-items: center;
				color: #333;
				font-size: 12px;
				line-height: 16px;

				&:not(:first-child) {
					margin-top: 7px;
				}
			}
		}
	}

	&-bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 20px;

		button + button {
			margin-left: 12px;
		}

		button {
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 156px;
			height: 36px;
			padding: 0;
			border: none;
			outline: none;
			box-sizing: border-box;
			border-radius: 5px;
			font-size: 14px;

			&:hover {
				opacity: 0.6;
			}

			&:active {
				opacity: 0.6;
				transform: scale(0.9);
			}
		}

		.switch-btn {
			border: 1px solid rgba(51, 51, 51, 1);
			background: #fff;
		}

		.renew-btn {
			background: linear-gradient(#fdedcf, #feefd3);
			color: #be8a0b;
			overflow: hidden;

			&:active {
				opacity: 1;
			}

			&:active::before {
				content: "";
				position: absolute;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.2);
			}

			i {
				display: inline-flex;
				align-items: center;
				margin-left: 4px;

				&::before {
					display: inline-block;
					font-size: 12px;
					transform: rotateZ(180deg);
				}
			}
		}
	}
	&-top {
		display: flex;
		align-items: center;

		.left {
			width: 68px;
			height: 68px;
			margin-right: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.right {
			color: #333;

			h1 {
				font-size: 20px;
				font-weight: 600;
				line-height: 28px;
			}

			p {
				display: flex;
				align-items: center;
				color: #333;
				font-size: 12px;
				line-height: 16px;

				&:not(:first-child) {
					margin-top: 7px;
				}
			}
		}
	}

	&-bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 20px;

		button + button {
			margin-left: 12px;
		}

		button {
			flex: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 156px;
			height: 36px;
			padding: 0;
			border: none;
			outline: none;
			box-sizing: border-box;
			border-radius: 5px;
			font-size: 14px;

			&:hover {
				opacity: 0.6;
			}

			&:active {
				opacity: 0.6;
				transform: scale(0.9);
			}
		}

		.switch-btn {
			border: 1px solid rgba(51, 51, 51, 1);
			background: #fff;
			cursor: pointer;
		}

		.renew-btn {
			background: linear-gradient(#fdedcf, #feefd3);
			color: #be8a0b;
			overflow: hidden;
			cursor: pointer;

			&:active {
				opacity: 1;
			}

			&:active::before {
				content: "";
				position: absolute;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.2);
			}

			i {
				display: inline-flex;
				align-items: center;
				margin-left: 4px;

				&::before {
					display: inline-block;
					font-size: 12px;
					transform: rotateZ(180deg);
				}
			}
		}
	}
}
</style>
